"use client";

export function Loading() {
  return (
    <div className="flex gap-4 items-center justify-center w-full h-screen">
      <div className="w-2 h-2 animate-ping rounded-full bg-gray-500" />
      <div className="w-2 h-2 animate-ping rounded-full bg-gray-500" />
      <div className="w-2 h-2 animate-ping rounded-full bg-gray-500" />
    </div>
  );
}
